import Screen from './Screen'

const DownloadApp = props => <Screen {...props} />

export default DownloadApp
